<template>
  <v-breadcrumbs :items="$route.meta.breadcrumbs" large />
</template>

<script>
export default {
  name: "AppBreadcrumbs"
};
</script>
